<template>
  <form class="add-participants-form" @submit.stop.prevent="handleSubmit">
    <search-input
      @search="(text) => searchText = text"
      class="search-input"/>
    <div class="people-list__wrapper">
      <add-participants-list
        @selectUser="selectUser"
        :enable-select="true"
        :selected="selectedUsers"
        :users="searchUnselectedContacts"
        :allow-focus="true"
        :show-delete-button="false"
        :show-phone="true"
      />
    </div>
    <div class="form-buttons">
      <button-app
        @clicked="cancelSubmit"
        type="button"
        class="form-button form-button_left"
        color-scheme="gray"
      >
        {{ $t('CP.cancel') }}
      </button-app>
      <button-app
        type="submit"
        class="form-button"
        color-scheme="blue"
        :disabled="selectedUsers.length === 0"
      >
        {{ $t('CP.add') }}
      </button-app>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { ADD_USER_SELECTED_CONTACTS } from '@/store/user/types';
import AddParticipantsList from '../../components/AddParticipantsList/AddParticipantsList';
import ButtonApp from '../../components/Button/ButtonApp';
import SearchInput from '../../components/SearchInput/SearchInput';
import functionsWithUser from '../../utils/mixins/functionsWithUser';

export default {
  name: 'AddFamilyParticipantsForm',
  components: {
    SearchInput,
    ButtonApp,
    AddParticipantsList,
  },
  extends: functionsWithUser,
  props: {
    parentModal: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedUsers: [],
      searchText: '',
    };
  },
  computed: {
    ...mapGetters(['userUnselectedContacts']),
    ...mapState({
      contacts: (state) => state.user.userContacts,
      user: (state) => state.user.user,
    }),
    searchUnselectedContacts() {
      const contacts = [];
      this.userUnselectedContacts.forEach((contact) => {
        const contactCopy = { ...contact };
        const userName = this.$getUserName(contactCopy);
        let { phone } = contactCopy;

        phone = phone.replace(/\D/g, '').toLowerCase().trim();
        const searchName = this.searchText.toLowerCase().trim().replace(/\s$/, '');
        const searchNameList = [
          searchName, // original
          this.$cyrillicToTranslit.reverse(searchName), // to cyrillic
          this.$cyrillicToTranslit.transform(searchName), // to latin
        ];
        const isSearchNameMatch = searchNameList.some((item) => (
          userName.toLowerCase().indexOf(item) !== -1
        ));
        const searchPhone = this.searchText.replace(/[+()-\s]/g, '');
        if (userName && isSearchNameMatch) {
          if (userName !== this.user.full_name) {
            contacts.push(contactCopy);
          }
        } else if (/^\d+$/.test(searchPhone) && phone.indexOf(searchPhone) !== -1 && searchPhone !== '') {
          if (userName !== this.user.full_name) {
            contacts.push(contactCopy);
          }
        }
      });
      return contacts.filter((user) => user.uid !== this.user.user);
    },
  },
  methods: {
    handleSubmit() {
      this.$store.commit(ADD_USER_SELECTED_CONTACTS,
        JSON.parse(JSON.stringify(this.selectedUsers)));
      this.selectedUsers = [];
      this.$emit('submit');
      this.$bvModal.hide(this.parentModal);
    },
    cancelSubmit() {
      this.selectedUsers = [];
      this.$emit('cancel');
      this.$bvModal.hide(this.parentModal);
    },
  },
};
</script>

<style lang='scss' scoped>
.add-participants-form {
  padding: 0 calc(32px - 1rem);
}

.people-list {
  max-height: 80vh;
}

.people-list__wrapper {
    max-height: 50svh;
    overflow-y: auto;
}
.search-input {
  font-size: 1rem;
  margin: 0 0 15px;
}
.form-buttons {
  display: flex;
}
.form-button {
  font-size: 13px;
  font-weight: bold;
  height: 38px;
  flex: 1 0 40%;
  margin: 0;
}
.form-button_left {
  margin: 0 8px 0 0;
}
</style>
